










import Vue from 'vue'
import api from '@/api'
import store from '@/store'

export default Vue.extend({
  name: 'SignupComplete',

  async mounted() {
    await api.completeSignup(store.state.signupId)
  },
})
